<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          v-if="active == 0"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item
                label="单位名称"
                prop="danwei"
                :rules="[
                { required: true, message: '单位名称不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.danwei"
                  type="text"
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="类型" prop="kaojitype"
                          :rules="[
                { required: true, message: '请选择类型', trigger: 'blur' },
              ]"
            >
              <el-radio-group v-model="formData.kaojitype">
                <el-radio :label="'考级中心'">考级中心</el-radio>
                <el-radio :label="'考级点'">考级点</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">

          <el-col :span="12" v-if="formData.kaojitype=='考级中心'">
            <el-form-item label="考级中心类型" prop="kaoji_jiameng_type"
                          :rules="[
                { required: true, message: '请选择考级中心类型' },
              ]"
            >
              <el-radio-group v-model="formData.kaoji_jiameng_type">
                <el-radio :label="'4'">指定考级中心（投入成本12万元）</el-radio>
                <el-radio :label="'5'">样板考级中心（投入成本13.5万元）</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-else>
            <el-form-item label="考级点类型" prop="kaoji_jiameng_type"
                          :rules="[
                { required: true, message: '请选择考级点类型' },
              ]"
            >
              <el-radio-group v-model="formData.kaoji_jiameng_type">
                <el-radio :label="'2'">指定考级点（投入成本0元）</el-radio>
                <el-radio :label="'3'">样板考级点（投入成本9800元）</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="单位执照" prop="zhizhaopic">
              <PicUploader :fileList="formData.zhizhaopic" :limit="1"></PicUploader>
              <div class="form-label-desc">上传营业执照 或 法人证书 或 组织结构代码证</div>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
                label="地区选择"
                prop="area"
                :rules="[
                {
                  required: true,
                  message: '请选择地区',
                  trigger: 'blur',
                },
              ]"
            >
              <el-cascader
                  v-model="formData.area"
                  ref="areas"
                  @change="handleAreasChange"
                  :options="areaOptions"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="详细地址"
                prop="address"
                :rules="[
                { required: true, message: '请输入详细地址', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.address"
                  type="text"
                  placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>负责人信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item
                label="姓名"
                prop="nickname"
                :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.nickname"
                  type="text"
                  placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="手机"
                prop="phone"
                :rules="[
                { required: true, validator: validator.phone,message:'请输入正确的手机号', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                  v-model="formData.phone"
                  type="text"
                  placeholder="请输入手机"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>日常联系人信息</el-divider>

        <el-row>
          <el-col :span="12">
            <el-form-item
                label="姓名"
                prop="contactsname"
                :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.contactsname"
                  type="text"
                  placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="手机"
                prop="contactsphone"
                :rules="[
                { required: true, validator: validator.phone,message:'请输入正确的手机号', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                  v-model="formData.contactsphone"
                  type="text"
                  placeholder="请输入手机"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">提交申请</el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
      <div class="step-three" v-if="active == 1 || active == 2">
        <van-form
            @submit="onSubmitThree"
            @failed="onFailed"
        >
          <van-cell-group>
            <div class="step-three-title">确认验收信息</div>
            <div class="step-three-content">
              <div>请确认您的创建清单：</div>
              <div class="step-three-danwei">{{ formData.danwei }} （{{ formData.kaojitype }}）</div>
              <div class="step-three-danwei" v-if="formData.kaoji_jiameng_type == 2">0元</div>
              <div class="step-three-danwei" v-else-if="formData.kaoji_jiameng_type == 3">9800元</div>
              <div class="step-three-danwei" v-else-if="formData.kaoji_jiameng_type == 4">12万元</div>
              <div class="step-three-danwei" v-else-if="formData.kaoji_jiameng_type == 5">13.5万元</div>
            </div>
            <van-cell title="请下载文化布置，发至广告公司制作">
            </van-cell>
            <div class="dialog-step-li" v-if="formData.kaojitype == '考级点'">
              <div class="dialog-step-li-text">
                <el-link  @click="download({name:'考级点文化包（兼容版）', url:'https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-10.zip'})">考级点文化包（兼容版）请下载制作</el-link>
              </div>
            </div>

            <div class="dialog-step-li" v-if="formData.kaojitype == '考级中心'">
              <div class="dialog-step-li-text">
                <el-link @click="download({name: '考级中心文化包（兼容版）', url:'https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-12.zip'})">考级中心文化包（兼容版）请下载制作</el-link>
              </div>
            </div>

            <van-cell title="请上传现场文化布置图">
            </van-cell>
            <div class="row">
              <PicUploader :fileList="formData.kaoji_yanshoufile" :limit="5"
                           :name="'kaoji_yanshoufile'"></PicUploader>

              <!--              <FileUploader uploadText="图片证明" :fileList="[]" :limit="1" :name="'yanshou_pic'"></FileUploader>-->
            </div>
          </van-cell-group>

          <el-row>
            <el-col class="footer-button">
              <el-button @click="onPay">我要付款</el-button>
              <el-button type="primary" @click="onSubmitThree" :loading="saveLoading">保存</el-button>
            </el-col>
          </el-row>
        </van-form>
      </div>

      <el-dialog :visible.sync="showPay" title="收款账户" :show-confirm-button="false" :close-on-click-overlay="true">
        <div style="width: 80%; text-align: center ; margin: 0px auto 20px;  font-size:14px;">
          <img style="width: 100%;"
               src="https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1625623675743-3.jpeg"/>
<!--          <van-button-->
<!--              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"-->
<!--              style="width: 3rem"-->
<!--              size="normal" round @click="onPayDownload">下载二维码-->
<!--          </van-button>-->
        </div>
      </el-dialog>

      <van-dialog :visible.sync="contactShow" title="联系人信息" :show-cancel-button="false" :close-on-click-overlay="true"
                  @close="onContactClose">
        <div style="width: 80%;margin: 0px auto 20px; ">
          <div>姓名：{{ contactRow.name }}</div>
          <div>电话：<a :href="'tel:'+contactRow.phone" style="color: #409eff">{{ contactRow.phone }}</a></div>
        </div>
      </van-dialog>

    </div>
  </div>
</template>
<style scoped>
.step-box {
  margin: 0 .2rem .2rem;
}

.dialog-step-li {
  margin: 0 15px 0;
}

.dialog-step-li-text {
  color: #409eff;
  margin-top: 3px;
}

.step-three-title {
  font-size: 24px;
  padding: 15px 0;
  text-align: center;
}

.step-three-content {
  margin: 0 .3rem;
  font-size: 16px;
}

.step-three-danwei {
  margin: 5px 0 15px;
}

/*.van-form .row {*/
/*  padding: 10px 15px;*/
/*  display: flex;*/
/*}*/
.step-two-box {
  padding: .4rem .2rem;
  font-size: 16px;
}

.step-two-box li {
  margin-bottom: .3rem;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Step,
  Steps,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  Sticky
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button).use(Steps).use(Step).use(Sticky);
export default {
  name: 'StationApplyMine',
  components: {
    PicUploader, FileUploader
  },
  data: function () {
    return {
      validator,
      loading: false,
      showPay: false,
      saveLoading: false,
      showArea: false,
      contactShow: false,
      active: 1,
      areaList: {},
      areaOptions: [],
      areaValue: '',
      submitType: '',
      submitThreeType: '',
      formData: {
        id: 0,
        areas: '',
        province: '',
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
        kaojitype: '考级中心',
        kaoji_jiameng_type: '',
        kaoji_yanshoufile: [],
//                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        changdipic: [],
//                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        zhizhaopic: [],
      },
      contactRow: {
        name: 'xx',
        phone: '111'
      }
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = "创建七彩星级"

//            if(that.formData.id){
    this.fetch();
//            }
    this.getAreaOptions()
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          that.formValidate = true;
          if (that.formData.kaojitype == '考级中心') {
            if (that.formData.kaoji_jiameng_type != 4 && that.formData.kaoji_jiameng_type != 5) {
              that.$message.warning('请选择考级中心类型');
              return;
            }
          } else if (that.formData.kaojitype == '考级点') {
            if (that.formData.kaoji_jiameng_type != 2 && that.formData.kaoji_jiameng_type != 3) {
              that.$message.warning('请选择考级点类型');
              return;
            }
          }

          for (let field in that.formData) {

            // if (that.formData.changdipic.length != 5) {
            //   Toast('请上传5张场地照片');
            //   return
            // }
            if (that.formData.zhizhaopic.length == 0) {
              that.$message.warning('请上传单位执照');
              return
            }
            if (!this.formData.area) {
              that.$message.warning('请选择地区');
              return
            }
          }

          that.saveLoading = true;

          if (that.submitType == 'save') {
            that.$api.post('/api/examecenter/save', that.formData, (res) => {
              that.saveLoading = false;
            }, (res) => {
              Toast.fail(res.msg);
              that.saveLoading = false;
            })
          } else {
            that.$api.post('/api/examecenter/applySimple', that.formData, (res) => {
              that.saveLoading = false;

              // 判断申请的是否是
              if (res.data.city.indexOf('佛山') >= 0) {
                // 邓晓茜 15919084409
                that.contactRow.name = '邓晓茜'
                that.contactRow.phone = '15919084409'
                that.contactShow = true
              } else if (res.data.city.indexOf('郑州') >= 0) {
                // 邓晓茜 15919084409
                that.contactRow.name = '邓晓茜'
                that.contactRow.phone = '15919084409'
                that.contactShow = true
              } else if (res.data.province.indexOf('湖南') >= 0) {
                // 邓晓茜 15919084409
                that.contactRow.name = '邓晓茜'
                that.contactRow.phone = '15919084409'
                that.contactShow = true
              } else {
                // 跳转改为步骤条进行
                that.active = 1
              }

              return
              rbLink({
                name: "QcxjStationResult",
                query: {
                  id: res.data.id
                }
              }, 'replace')
            }, (res) => {
              that.$message.warning(res.msg);
              that.saveLoading = false;
            })
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      if (that.formData.kaojitype == '考级中心') {
        if (that.formData.kaoji_jiameng_type != 4 && that.formData.kaoji_jiameng_type != 5) {
          Toast('请选择考级中心类型');
          return;
        }
      } else if (that.formData.kaojitype == '考级点') {
        if (that.formData.kaoji_jiameng_type != 2 && that.formData.kaoji_jiameng_type != 3) {
          Toast('请选择考级点类型');
          return;
        }
      }

      for (let field in that.formData) {

        // if (that.formData.changdipic.length != 5) {
        //   Toast('请上传5张场地照片');
        //   return
        // }
        if (that.formData.zhizhaopic.length == 0) {
          Toast('请上传单位执照');
          return
        }
        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
      }

      that.saveLoading = true;

      if (that.submitType == 'save') {
        that.$api.post('/api/examecenter/save', that.formData, (res) => {
          that.saveLoading = false;
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      } else {
        that.$api.post('/api/examecenter/applySimple', that.formData, (res) => {
          that.saveLoading = false;

          // 判断申请的是否是
          if (res.data.city.indexOf('佛山') >= 0) {
            // 邓晓茜 15919084409
            that.contactRow.name = '邓晓茜'
            that.contactRow.phone = '15919084409'
            that.contactShow = true
          } else if (res.data.city.indexOf('郑州') >= 0) {
            // 邓晓茜 15919084409
            that.contactRow.name = '邓晓茜'
            that.contactRow.phone = '15919084409'
            that.contactShow = true
          } else if (res.data.province.indexOf('湖南') >= 0) {
            // 邓晓茜 15919084409
            that.contactRow.name = '邓晓茜'
            that.contactRow.phone = '15919084409'
            that.contactShow = true
          } else {
            // 跳转改为步骤条进行
            that.active = 1
          }

          return
          rbLink({
            name: "QcxjStationResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      }
    },

    onSubmitThree(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;

      // if (that.submitThreeType == 'show' || !that.submitThreeType) return
      console.log(that.formData)
      // return
      that.formValidate = true;

      if (this.formData.kaoji_yanshoufile.length < 3) {
        that.$message.warning('请至少上传3张文化布置图');
        return
      }
      that.saveLoading = true;

      that.$api.post('/api/examecenter/fileEdit', that.formData, (res) => {
        that.saveLoading = false;
        that.$message.success('保存成功')
        rbLink({
          name: "ClubIndex",
          query: {
            id: res.data.id
          }
        }, 'back')
      }, (res) => {
        that.$message.error(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },

    // 我要付款
    onPay() {
      this.submitThreeType = 'show'
      this.showPay = true
    },

    onPayDownload() {
      this.download({
        name: '啦啦操收款二维码',
        url: 'https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1625623675743-3.jpeg'
      })
    },

    download(file) {
      appEvent({
        name: 'downloadFile',
        query: {
          name: file.name,
          url: file.url,
        }
      });
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
      this.submitThreeType = 'submit';
    },

    onContactClose() {
      this.active = 1
    },

    fetch() {
      let that = this;
      that.$api.post('/api/examecenter/centerdetail', {
        id: that.formData.id
      }, (res) => {
        that.loading = true
        that.formData = res.data;
        if (res.data.kaojiregist_status == 1) {
          that.active = 1;
          return;
          rbLink({
            name: "QcxjStationResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        } else if (res.data.kaojiregist_status == 2) {
          that.active = 2;
        }
      }, (res) => {
        that.loading = true
//                    Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// StationApplyMine.vue?715ff6b6